/**
 * Build the JSON-stringified `dialerRows` body field that the legacy
 * `/api/obd/group` and `/api/obd/group/update` endpoints expect — a
 * nested `{ dialersList: [{ dialerId, dialerName }, ...] }` object.
 */
export function buildDialerRowsPayload(
  dialerIds: string[],
  options: Array<{ value: string; label: string }>,
): string {
  return JSON.stringify({
    dialersList: dialerIds.map((id) => ({
      dialerId: Number(id),
      dialerName: options.find((o) => o.value === id)?.label ?? '',
    })),
  });
}
